import { useEffect, useState } from "react";
import Menu from "../Menubar/Menu";
import { FehlerauswertungErrResp } from "../Fehler/FehlerauswertungErrResp";
import { Categories } from "../MainMenu/MenüSicht";

var MonitorApi = require('monitor-api');

export default function Nutzer({ myApiClient, setSection }) {
    var loginInstance = new MonitorApi.LoginApi(myApiClient);

    const [username] = useState(sessionStorage.getItem('user'));
    const [levels] = useState(sessionStorage.getItem('token'));

    const [newPw, setNewPw] = useState(new MonitorApi.ApiPasswort('', ''));
    const [showSucces, setShowSucces] = useState(false);

    const translateLevelToDescription = (givenLevels) => {
        if (levels.includes("level2")) {
            return "Admin"
        }
        if (levels.includes("level1")) {
            return "alle Zweckverbände einsehbar"
        }
        if (levels.includes("level0")) {
            return "eingeschränkter Zugriff"
        }
    }
    const levelDescription = translateLevelToDescription(levels);

    useEffect(() => {
        setSection('Benutzerkonto - Passwort ändern');
    }, [setSection]);

    const registerNewPassword = e => {
        e.preventDefault();
        console.log(newPw);
        loginInstance.updateOwnPassword(newPw, (error, data,response) => {
            if (error) {
                setShowSucces(false);
                console.log(error);
                    FehlerauswertungErrResp(error, response);
            } else {
                setShowSucces(true);
                setNewPw(
                    {'password': "",
                    'passwordRepeat': ""}
                )
        }
    });
    }

    return (
        <div className="next-to-menu">
            <Menu/>
            <Categories>
                <form className="details-acc" onSubmit={registerNewPassword}>
                    <label>Benutzername: {username} </label>
                    <label>Benutzerrechte: {levelDescription} </label>
                    <label>neues Passwort:
                        <input type="password" value={newPw.password} onChange={e => setNewPw(pre => ({...pre, 'password': e.target.value}))} required={true}/>
                    </label>
                    <label>neues Passwort wiederholen:
                        <input type="password" value={newPw.passwordRepeat} onChange={e => setNewPw(pre => ({...pre, 'passwordRepeat': e.target.value}))} required={true}/>
                    </label>
                    <button type="submit">Passwort ändern</button>
                </form>
                {showSucces && <p style={{color: "green"}}>Passwort erfolgreich geändert.</p>}
            </Categories>
        </div>
    )
}